// Wolfhound Pouches - Custom JavaScript
// Extracted from theme.liquid for maintainability.
// This file is referenced in layout/theme.liquid.
// When updating the Dawn base theme, ensure the following line is preserved in theme.liquid:
//   <script src="{{ 'wolfhound-custom.js' | asset_url }}" defer="defer"></script>

// Tab switcher used by product page description/ingredients tabs (main-product.liquid)
function openTab(evt, tabId) {
  var tabs = evt.currentTarget.closest('.custom-tabs');
  tabs.querySelectorAll('.tab-section').forEach(function (el) { el.classList.remove('active'); });
  tabs.querySelectorAll('.tab-button').forEach(function (el) { el.classList.remove('active'); });
  tabs.querySelector('#' + tabId).classList.add('active');
  evt.currentTarget.classList.add('active');
}

// Flavour + pack option styling — runs once on load and re-runs on variant change
document.addEventListener("DOMContentLoaded", function () {

  // --- Flavour label colours ---
  var labelColors = {
    "Oráiste | Orange": "#D24C0D",
    "Cuirín Dubh | Blackcurrant": "#7A297A",
    "Caife | Coffee": "#D3A375",
    "Miontas Mín | Spearmint": "#1C93A7",
    "Leann Úll | Apple Cider": "#5BA644",
    "Cóla | Cola": "#681716",
    "Bosca Measctha | Mixed Pack": "#FFC0CB",
    "Default": "#009A44",
    "Slim": "#009A44"
  };

  function styleLabels() {
    var pillInputs = document.querySelectorAll('.product-form__input--pill input');
    pillInputs.forEach(function (input) {
      var label = input.nextElementSibling;
      if (!label) return;
      var flavour = Object.keys(labelColors).find(function (f) {
        return input.value.trim().startsWith(f);
      });
      if (!flavour) return;

      label.dataset.flavour = flavour;
      label.style.setProperty('--label-color', labelColors[flavour]);
      label.classList.remove('is-active', 'gradient-bg');
    });

    var checkedInput = document.querySelector('.product-form__input--pill input[type="radio"]:checked');
    if (checkedInput) {
      var activeLabel = document.querySelector('label[for="' + checkedInput.id + '"]');
      if (activeLabel) {
        activeLabel.classList.add('is-active');
        if (activeLabel.dataset.flavour === "Bosca Measctha | Mixed Pack") {
          activeLabel.classList.add('gradient-bg');
        }
      }
    }
  }

  // --- Pack size option styling (targets variant group index 1) ---
  function stylePackOptions() {
    var fieldsets = document.querySelectorAll('.product-form__input--pill');
    fieldsets.forEach(function (fieldset, groupIndex) {
      var radios = fieldset.querySelectorAll('input[type="radio"]');
      radios.forEach(function (radio, optionIndex) {
        var id = 'variant-option-' + groupIndex + '-' + optionIndex;
        radio.id = id;

        var label = fieldset.querySelector('label[for="' + id + '"]');
        if (!label || label.tagName !== 'LABEL') {
          var sibling = radio.nextElementSibling;
          if (sibling && sibling.tagName === 'LABEL') label = sibling;
        }

        if (label) {
          label.setAttribute('for', id);
          label.style.borderRadius = '10px';
          label.style.padding = '10px 16px';
          label.style.margin = '6px';
          label.style.display = 'inline-block';
          label.style.transition = 'all 0.25s ease';
          label.style.fontWeight = '600';

          var isTarget = groupIndex === 1; // pack-size group
          if (isTarget) {
            if (radio.checked) {
              label.style.backgroundColor = '#009A44';
              label.style.color = '#fff';
              label.style.border = 'none';
            } else {
              label.style.backgroundColor = '#fff';
              label.style.color = '#009A44';
              label.style.border = '1px solid #009A44';
            }
          }
        }
      });
    });
  }

  // Run both on load
  styleLabels();
  stylePackOptions();

  // Re-run on any radio change (single delegated listener)
  document.addEventListener('change', function (e) {
    if (e.target.matches('.product-form__input--pill input[type="radio"]')) {
      styleLabels();
      stylePackOptions();
    }
  });

  // Re-run if Dawn re-renders the form via JS (e.g. variant switching)
  var form = document.querySelector('form[data-type="add-to-cart-form"]');
  if (form) {
    new MutationObserver(function () {
      styleLabels();
      stylePackOptions();
    }).observe(form, { childList: true, subtree: true });
  }
});
